export default __webpack_public_path__ + "static/media/ZipRecruiter_Logo.9ded50e6.svg";